module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-09-14 at 18.41.49_2138c53b.76c07458.jpg";